import { useMemo } from "react";
import { useFolders } from "../projects/folders.ts";
import { wikiFolderIndex, wikiNeighbours } from "../projects/knowledge-tree.ts";
import { useWikiIndex } from "./queries.ts";

/**
 * The previous and next pages of `pageId` in its folder, from the reader-filtered index and the
 * folder list the tree already loads (no request of their own): a hidden page is never a
 * neighbour, as the index never holds it.
 */
export function useFolderNeighbours(projectId: string, pageId: string) {
  const pages = useWikiIndex(projectId).data?.pages;
  const folders = useFolders(projectId).data?.folders;
  return useMemo(
    () =>
      pages && folders ? wikiNeighbours(pages, folders, pageId) : { previous: null, next: null },
    [pages, folders, pageId],
  );
}

/** The index of a Wiki folder (null while loading, or for an unknown folder). */
export function useWikiFolderIndex(projectId: string, folderId: string) {
  const pages = useWikiIndex(projectId).data?.pages;
  const folders = useFolders(projectId).data?.folders;
  return useMemo(
    () => (folderId && pages && folders ? wikiFolderIndex(pages, folders, folderId) : null),
    [pages, folders, folderId],
  );
}
